<template>
  <model-crud
    ref="crud"
    :model="model"
    :fields="fields"
    :include="include"
    :extended="true"
    :atferSave="atferSave"
    :fetchFilters="fetchFilters"
    :form-order="formOrder"
  />
</template>

<script>
import ModelCrud from '@/components/ModelCrud'
import User from '@/models/User'
import Company from '@/models/Company'
import CompanyGroup from '@/models/CompanyGroup'
import PasswordInput from '@/components/PasswordInput'
import Line from '@/models/Line'
import LineGroup from '@/models/LineGroup'

export default {
  data () {
    let roles = []

    if (this.$auth.hasRole('SUPER_ADMIN')) {
      roles = roles.concat(['SUPER_ADMIN', 'GROUP_ADMIN'])
    }

    if (this.$auth.hasRole('GROUP_ADMIN')) {
      roles = roles.concat(['COMPANY_ADMIN'])
    }

    if (this.$auth.hasRole('COMPANY_ADMIN')) {
      roles = roles.concat(['COMPANY_ADMIN', 'COMPANY_USER'])
    }

    return {
      model: User,
      include: [ 'company', 'companyGroups', 'assignedTargets', 'assignedTargetGroups' ],
      fetchFilters: {
        'id': '[NEQ]' + this.$store.auth.user.id,
        'role': '[IN]' + roles.join(',')
      },
      formOrder: [
        'username',
        'note',
        'name', 'surname',
        'role',
        'email',
        'password', 'password2',
        'company',
        'companyGroups',
        'assignedTargets',
        'assignedTargetGroups',
        'allowedHosts',
        'enabled',
        'companyAuditor',
        'sendInfo',
        'changePasswordAfterLogin'
      ]
    }
  },
  computed: {
    fields () {
      let self = this
      let availableRoles = []

      if (this.$auth.hasRole('SUPER_ADMIN')) {
        availableRoles = availableRoles.concat(['SUPER_ADMIN', 'GROUP_ADMIN'])
      }

      if (this.$auth.hasRole('GROUP_ADMIN')) {
        availableRoles = availableRoles.concat(['COMPANY_ADMIN'])
      }

      if (this.$auth.hasRole('COMPANY_ADMIN')) {
        availableRoles = availableRoles.concat(['COMPANY_ADMIN', 'COMPANY_USER'])
      }

      let roleEnum = availableRoles.reduce((roles, role) => {
        roles[role] = User.enums.role[role]
        return roles
      }, {})

      let fields = {
        username: {
          label: this.$t('headers.username'),
          required: true,
          rules: [
            function (value) {
              return self.$refs.crud.items.find(item => item.username === value && item._self !== this._self) ? 'Musí být unikátní' : true
            }
          ],
          fill: true
        },
        note: {
          label: this.$t('headers.note'),
          fill: true,
          multiLine: true,
          displayLength: 20
        },
        name: { label: this.$t('headers.personName'), formOrder: 1, required: true },
        surname: { label: this.$t('headers.surname'), formOrder: 2, required: true },
        email: { label: this.$t('headers.email'), formOrder: 4, required: true, fill: true },
        role: {
          label: 'Role',
          type: 'enum',
          values: roleEnum,
          default: this.$auth.hasRole('GROUP_ADMIN') ? 'COMPANY_ADMIN' : null,
          roles: ['SUPER_ADMIN', 'GROUP_ADMIN', 'COMPANY_ADMIN'],
          fill: true,
          required: true
        },
        companyGroups: {
          label: this.$t('headers.companyGroups'),
          type: 'references',
          model: CompanyGroup,
          roles: ['SUPER_ADMIN'],
          requires: {
            role: 'GROUP_ADMIN'
          },
          required: true,
          fill: true
        },
        company: {
          label: this.$t('headers.company'),
          type: 'reference',
          model: Company,
          roles: ['GROUP_ADMIN'],
          requires: 'role',
          requiresValue: 'COMPANY_ADMIN',
          required: true,
          fill: true
        },
        password: {
          label: this.$t('headers.password'),
          type: 'custom',
          input: PasswordInput,
          list: false,
          filterable: false,
          required: 'create'
        },
        password2: {
          label: this.$t('headers.passwordAgain'),
          type: 'custom',
          input: PasswordInput,
          otherPassword: 'password',
          list: false,
          filterable: false,
          required: 'create'
        },
        assignedTargets: {
          label: this.$t('headers.targets'),
          roles: ['COMPANY_ADMIN'],
          type: 'references',
          model: Line,
          fill: true,
          list: false,
          requires: {
            role: 'COMPANY_USER'
          }
        },
        assignedTargetGroups: {
          label: this.$t('headers.targetGroups'),
          roles: ['COMPANY_ADMIN'],
          type: 'references',
          model: LineGroup,
          fill: true,
          list: false,
          requires: {
            role: 'COMPANY_USER'
          }
        },
        companyAuditor: {
          label: this.$t('headers.companyAuditor'),
          type: 'bool',
          list: false,
          filterable: true,
          fill: true,
          roles: ['COMPANY_ADMIN'],
          requires: {
            role: 'COMPANY_USER'
          }
        },
        sendInfo: {
          label: this.$t('headers.sendInfo'),
          type: 'bool',
          list: false,
          filterable: false,
          fill: true,
          default: true,
          createOnly: true
        },
        changePasswordAfterLogin: {
          label: this.$t('headers.changePasswordAfterLogin'),
          type: 'bool',
          list: false,
          filterable: false,
          fill: true
        },
        allowedHosts: {
          label: this.$t('headers.allowedHosts'),
          hint: this.$t('headers.allowedHostsHint'),
          type: 'text',
          multiLine: true,
          list: false,
          fill: true
        },
        enabled: {
          label: this.$t('headers.enabled'),
          type: 'bool',
          default: true,
          fill: true
        }
      }

      return fields
    }
  },
  methods: {
    atferSave (result, item, fields) {
      let promise = Promise.resolve()
      if (item.password) {
        result.password = item.password
        promise.then(() => User.setPassword(result))
      }
      if (item.sendInfo) {
        result.password = item.password
        promise.then(() => User.sendInfo(result))
      }
    }
  },
  components: {
    ModelCrud
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// Users.vue?08dd19c2